const Data = [
    {
        name: "Satvik Jaiswal",
        position: "President",
        imageUrl: "/assets/images/members/GB25/Satvik Jaiswal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100089660656382&mibextid=rS40aB7S9Ucbxw6v",
        linkedinLink: "https://www.linkedin.com/in/satvik-j",
        email: "satvik.jaiswal@gyws.org",
    },
    {
        name: "Afeerah Naseem",
        position: "Vice President",
        imageUrl: "/assets/images/members/GB25/Afeerah Naseem.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087581197416",
        linkedinLink: "https://www.linkedin.com/in/afeerah-naseem-59278a268/",
        email: "afeerah.naseem@gyws.org"
    },
    {
        name: "Aditya Singh Yadav",
        position: "General Secretary",
        imageUrl: "/assets/images/members/GB25/Aditya.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087545650107",
        linkedinLink: "https://www.linkedin.com/in/aditya-yadav-7ab715269/",
        email: "aditya.yadav@gyws.org"
    },
    {
        name: "Vidit Om",
        position: "Assistant Secretary",
        imageUrl: "/assets/images/members/GB25/Vidit Om.jpg",
        facebookLink: "https://www.facebook.com/people/Vidit-Om/pfbid02C29CxeZZA6F135ehhaPZjKZWUnEY2zwPi4uRhhFeEtpg7e8PBGCaAynvsEb8N4GYl/?sk=about",
        linkedinLink: "https://www.linkedin.com/in/vidit-om-b11885256/",
        email: "vidit.om@gyws.org"
    },
    {
        name: "Swaralipi Datta",
        position: "Human Resource Manager",
        imageUrl: "/assets/images/members/GB25/Swaralipi Datta.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087185364901",
        linkedinLink: "https://www.linkedin.com/in/swaralipi-datta04/",
        email: "swaralipi.datta@gyws.org"
    },
    {
        name: "Megha Singhal",
        position: "Chief Executive Officer, LiGHT",
        imageUrl: "/assets/images/members/GB25/Megha Singhal.jpg",
        facebookLink: "https://www.facebook.com/megha.singhal.35325/",
        linkedinLink: "https://www.linkedin.com/in/megha-singhal-7a9a3926a/",
        email: "megha.singhal@gyws.org"
    },
    {
        name: "Jatin Mahawar",
        position: "Chief Technical Officer",
        imageUrl: "/assets/images/members/GB25/JatinMahawar.jpg",
        facebookLink: "https://www.facebook.com/jatin.m.376695?mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/jatin-mahawar-b086a4253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "jatin.mahawar@gyws.org"
    },
    {
        name: "Saurabh Chavan",
        position: "Treasurer",
        imageUrl: "/assets/images/members/GB25/Saurabh Chavan.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087932744081&mibextid=JRoKGi",
        linkedinLink: "https://www.linkedin.com/in/saurabh-chavan-961819251?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "saurabh.chavan@gyws.org"
    },
    {
        name: "Tvisha Khakhar",
        position: "School Development Officer",
        imageUrl: "/assets/images/members/GB25/Tvisha.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087648426543&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/tvisha-khakhar-a71547250",
        email: "tvisha@gyws.org"
    },
    {
        name: "Adeeba Alam Ansari",
        position: "Chief Fundraising Officer",
        imageUrl: "/assets/images/members/GB25/Adeeba Alam Ansari.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087442703521",
        linkedinLink: "https://www.linkedin.com/in/adeeba-alam-ansari-b3aba1252/",
        email: "adeeba.ansari@gyws.org"
    },
    {
        name: "Siddhesh Agrawal",
        position: "Foreign and Corporate Relations Officer",
        imageUrl: "/assets/images/members/GB25/Siddhesh Agarwal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100086241404924",
        linkedinLink: "https://www.linkedin.com/in/siddhesh-agrawal-3ba110252/",
        email: "siddhesh.agrawal@gyws.org"
    },
    {
        name: "Utkarsh",
        position: "Donor Engagement Officer",
        imageUrl: "/assets/images/members/GB25/Utkarsh.jpg",
        facebookLink: "https://m.facebook.com/people/Utkarsh-Chaand/100086954527870/",
        linkedinLink: "https://www.linkedin.com/in/utkarsh-246903274",
        email: "utkarsh@gyws.org"
    },
    {
        name: "Anmol Singh",
        position: "Public Relations Officer",
        imageUrl: "/assets/images/members/GB25/Anmol Singh.jpg",
        facebookLink: "https://m.facebook.com/profile.php?id=100007010851430",
        linkedinLink: "https://www.linkedin.com/in/anmol-singh-55025b259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        email: "anmol.singh@gyws.org"
    },
    {
        name: "Nazmi Syed",
        position: "Hostel Committee Officer",
        imageUrl: "/assets/images/members/GB25/Nazmi Syed.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087177596392&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/nazmi-syed-63980b269",
        email: "nazmi.syed@gyws.org"
    },
    {
        name: "Lokesh Saran",
        position: "Chief Executive Officer, RISE",
        imageUrl: "/assets/images/members/GB25/Lokesh Sharan.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087515113955&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/lokesh-saran-b0535925",
        email: "lokesh.saran@gyws.org"
    }
]

export default Data;